var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('active-list'),_c('alert-modal',{attrs:{"title":_vm.alertModalTitle,"icon":_vm.alertModalIcon,"active":_vm.alertModalActive,"content":_vm.alertModalContent,"btnOk":_vm.alertModalBtnOk,"callback":_vm.alertModalCallback},on:{"ok":function($event){_vm.alertModalActive=false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }